module.exports = __webpack_public_path__ + "static/Fcoin-fe91d39675e5de94fbfd2b2d6875b46d.png";